import { createContext, useContext } from 'react';

/**
 * Context that exposes whether the AuthorizationKey has been validated/refreshed
 * and is ready to be used in API calls. Queries should skip until this is true
 * to prevent race conditions with stale keys.
 */
export const AuthKeyContext = createContext<boolean>(false);

export const useAuthKeyReady = () => useContext(AuthKeyContext);
